import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Box, CircularProgress } from '@mui/material';
import { PageWrapper } from '../../styledComponents/wrappers';
import LpuOrderDetailLayout from './LpuOrderDetailLayout';
import { LpuOrder } from '../../services/fulfillment/types';
import { getLpuOrder, stageOrder } from '../../services/fulfillment/lpuApi';
import { LPU_QUEUE_ROUTE } from './LpuQueue';

const LpuStagingDetail: React.FC = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const [order, setOrder] = useState<LpuOrder | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const id = parseInt(orderId, 10);
    getLpuOrder(id)
      .then(o => {
        if (!o) {
          setError('Order not found.');
          return;
        }
        setOrder(o);
      })
      .finally(() => setLoading(false));
  }, [orderId]);

  if (loading || !order) {
    return (
      <PageWrapper>
        {error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        )}
      </PageWrapper>
    );
  }

  return (
    <LpuOrderDetailLayout
      order={order}
      pageTitle="Stage for Pickup"
      instruction="Review all items are present before moving to the LPU buffer."
      actionLabel="Ready to Pickup"
      actionInProgressLabel="Moving to LPU Buffer…"
      successHeading="Moved to LPU Buffer"
      successInstruction="Move the items to the Pickup Buffer. The customer will be notified that their order is ready."
      backLabel="LPU Queue"
      backRoute={LPU_QUEUE_ROUTE}
      onAction={() => stageOrder(order.shopifyOrderId)}
    />
  );
};

export default LpuStagingDetail;
